module.exports = __webpack_public_path__ + "media/bootstrap-icons/speedometer2-9bf781ad.svg";